<template>
    <div class="wrapper">
        <h1 class="crumb">询价单列表</h1>
        <el-table
            :data="ProjectList"
            style="width: 100%;margin-top: 20px;">
            <el-table-column type="expand">
                <template slot-scope="props">
                    <el-table
                        :data="props.row.goods"
                        style="width:100%;border: 1px solid #f56c31">
                        <el-table-column prop="goods_name" label="商品" align="center"></el-table-column>
                        <el-table-column prop="goods_price" label="价格" align="center"></el-table-column>
                        <el-table-column prop="goods_number" label="数量" align="center"></el-table-column>
                        <el-table-column  label="是否已下单" align="center">
                            <template slot-scope="props">
                                {{props.row.status === '0'?'未下单':'已下单'}}
                            </template>
                        </el-table-column>
                    </el-table>
                </template>
            </el-table-column>
            <el-table-column prop="login_account" label="登录号" align="center"></el-table-column>
            <el-table-column prop="address" label="地址" align="center"></el-table-column>
            <el-table-column label="型号"  align="center">
                <template slot-scope="props">
                    <div v-for="item in props.row.goods" style="font-size: 10px">{{item.goods_name}}</div>
                </template>
            </el-table-column>
            <el-table-column label="数量" width="50" align="center">
                <template slot-scope="props">
                    <div v-for="item in props.row.goods">{{item.goods_number}}</div>
                </template>
            </el-table-column>
            <el-table-column label="金额" width="120"  align="center">
                <template slot-scope="props">
                    <div v-for="item in props.row.goods">￥{{+item.goods_price}}元</div>
                </template>
            </el-table-column>
            <el-table-column  label="是否已下单" width="100" align="center">
                <template slot-scope="props">
                    <div v-for="item in props.row.goods" :style="item.status==='0'?{color:'red'}:{color:'green'}">{{item.status === '0'?'未下单':'已下单'}}</div>
                </template>
            </el-table-column>
            <el-table-column prop="content" label="备注" align="center"></el-table-column>
            <el-table-column  label="操作" align="center">
                <template slot-scope="props">
                    <el-button type="text" size="small" @click="returnInq(props.row.id)">退回询价单</el-button><span style="color: #409EFF"> | </span>
                    <el-button type="text" size="small" @click="showOrders(props.row)">下单</el-button>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination
            @current-change="handleCurrentChange"
            layout="total, prev, pager, next"
            :total="total">
        </el-pagination>
        <el-dialog
            title="项目下单"
            :visible.sync="ShowOrder"
            width="700px"
            >

            <el-table :data="goods" empty-text="该项目已无商品可下单" style="border: 1px solid #f56c31" @selection-change="handleSelectionChange">
                <el-table-column
                    type="selection"
                    width="55"
                >
                </el-table-column>
                <el-table-column label="商品名称" prop="goods_name" align="center"></el-table-column>
                <el-table-column label="价格" prop="goods_price" align="center"></el-table-column>
                <el-table-column label="数量" prop="goods_number" align="center" width="100px"></el-table-column>
            </el-table>
            <span slot="footer" class="dialog-footer">
    <el-button @click="ShowOrder = false">取 消</el-button>
    <el-button type="primary" @click="order">确 定</el-button>
  </span>
        </el-dialog>

    </div>
</template>
<script>
    import {ProjectList, ProjectToInq, OrderInquiry} from "../stores/api";

    export default {
        data() {
            return {
                page: 1,
                total: '',
                ProjectList: [],
                ShowOrder: false,
                goods: [],
                address_id: '',
                selectGoods: [],
            }
        },
        created () {
            this.getProjectList()
        },
        methods: {
            getProjectList () {
                let temp = {}
                temp.page = this.page
                ProjectList(temp).then(res => {
                    if (res.data.error === 0) {
                        this.ProjectList = res.data.list
                        this.total = res.data.count
                    }
                })
            },
            //退回询价单
            returnInq (id) {
                let temp = {}
                temp.id = id
                this.$confirm('确定退回该询价单?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'success'
                }).then(() => {
                    //退回询价单
                    ProjectToInq(temp).then(res => {
                        if (res.data.error === 0) {
                            this.$message({
                                type: 'success',
                                message: res.data.msg
                            });
                            this.getProjectList()
                        }
                    })
                })
            },
            showOrders (row) {
                this.ShowOrder = true
                this.goods = []
                if (row.goods) {
                    row.goods.forEach(item => {
                        if (item.status === '0') {
                            this.goods.push(item)
                        }
                    })
                }
                this.address_id = row.address_id
            },
            handleSelectionChange (val) {
                this.selectGoods = val
            },
            //项目下单
            order () {
                let goods = []
                console.log(this.selectGoods)
                this.selectGoods.forEach(item => {
                    goods.push({ id: item.id, goods_attr: item.goods_attr, goods_attr_id: item.goods_attr_id, goods_id: item.goods_id, goods_name: item.goods_name, goods_number: item.goods_number, goods_price: Number(item.goods_price), })
                })
                let data = {
                    address_id: this.address_id,
                    goods: goods,
                }
                // console.log(data)
                OrderInquiry(data).then(res => {
                    if (res.data.error === 0) {
                        this.$message.success(res.data.msg)
                        this.getProjectList()
                        this.ShowOrder = false
                    } else if (res.data.error === 1) {
                        this.$message.error(res.data.msg)
                    }
                })
            },
            //点击换页
            handleCurrentChange (val) {
                this.page = val
                this.getInqueryList()
            },
        }
    }
</script>
<style lang="less" scoped>

</style>
<style>
    .el-table th>.cell{
        color: #f56c31;
    }
    .el-dialog__body {
        padding: 30px 30px;
    }
</style>



// WEBPACK FOOTER //
// src/router/ProjectList.vue